/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', e => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  showSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.form.element.setAttribute('aria-hidden', true)
  }

  async backInStockSubscribe (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.showSuccess()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  async newsletterSubscribe (emailAddress) {
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailAddress,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: window.theme.klaviyo.newsletterListID,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.showNewsletterSuccess()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId

    if (!variantId) {
      const sizeOptionEl = document.querySelector('[data-variant-radios-el="option"][data-name="size"]')
      const sizeOptionTextEl = sizeOptionEl.querySelector('[data-variant-radios-el="option-text"]')

      if (!sizeOptionEl && !sizeOptionTextEl) return

      sizeOptionEl.scrollIntoView({ behavior: 'smooth', block: 'center' })

      sizeOptionTextEl.innerText = window.theme.strings.selectSize
      sizeOptionEl.classList.add('prd-DetailVariants_Row-required')

      return
    }

    const emailAddress = this.els.email.element.value

    this.backInStockSubscribe(variantId, emailAddress)

    if (!this?.els?.newsletter?.exists) return

    if (this.els.newsletter.element.checked === true) {
      this.newsletterSubscribe(emailAddress)
    }
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
